import {linkEmplOrganizerDocument} from "app/employee/core/employeeLinks";
import {IonIcon, IonItem, IonLabel} from "@ionic/react";
import {FlexCellFull, FlexRow} from "app/employee/flexUtils";
import {documentOutline} from "ionicons/icons";
import {DocumentIcon} from "app/employee/organizer/folder/DocumentIcon";
import type {EmployeeLocationFragment, OrganizerDocumentFragment} from "app/gql/graphqlSchema";

interface Props {
  document: OrganizerDocumentFragment;
  location: EmployeeLocationFragment;
}

export const DocumentItem = ({location, document}: Props) => {
  return (
    <IonItem detail lines="full" routerLink={linkEmplOrganizerDocument(location.id.locationId, document.id.documentId)}>
      <IonLabel>
        <FlexRow>
          <FlexCellFull>
            <IonIcon icon={documentOutline} />
          </FlexCellFull>
          <span>{document.name}</span>
        </FlexRow>
      </IonLabel>
      <FlexRow slot="end">
        <FlexCellFull>
          <DocumentIcon document={document} />
        </FlexCellFull>
      </FlexRow>
    </IonItem>
  );
};
